type ProductSlugs = {
  slug: string;
  slug_en: string;
  slug_nl: string;
  slug_de: string;
  slug_fr: string;
  slug_es: string;
  slug_it: string;
};

/** Whether `product` is the one at `slug`, in any of its languages' URLs. */
export const isProductAtSlug = (
  product: ProductSlugs,
  slug: string | string[] | undefined
) =>
  typeof slug === "string" &&
  [
    product.slug,
    product.slug_en,
    product.slug_nl,
    product.slug_de,
    product.slug_fr,
    product.slug_es,
    product.slug_it,
  ].includes(slug);
